// external

import { Turbo } from "@hotwired/turbo-rails"
import "@oddcamp/cocoon-vanilla-js"
import "../javascripts/site/controllers"

// Disable Turbo Drive globally; only Turbo Frames (e.g. the mission
// search results frame) should perform Turbo-driven navigation.
// Regular page-to-page links and form submissions fall back to full
// browser navigation.
Turbo.session.drive = false

// internal
import "../javascripts/shared/base/polyfills"
import "../javascripts/shared/base/rails"
import "../javascripts/shared/base/omasks"
import "../javascripts/shared/base/form"
import "../javascripts/shared/base/linkable"
import "../javascripts/shared/base/sentry"

import "../javascripts/shared/components/show-more-filters"
import "../javascripts/shared/components/dropdown-checkboxes"
import "../javascripts/shared/components/header"
import "../javascripts/shared/components/modal"
import "../javascripts/shared/components/tooltip"
import "../javascripts/shared/components/default-modal"
import "../javascripts/shared/components/carousel-modal"
import "../javascripts/shared/components/tabbed-content"
import "../javascripts/shared/components/cards-carousel"
import "../javascripts/shared/components/share-bar"
import "../javascripts/shared/components/search-box"
import "../javascripts/shared/components/tags-carousel"
import "../javascripts/shared/components/choices"
import "../javascripts/shared/components/follow"
import "../javascripts/shared/components/location-input"
import "../javascripts/shared/components/copy-link"
import "../javascripts/shared/components/floating-label-field"
import "../javascripts/shared/components/flash-message"
import "../javascripts/shared/components/form-error-summary"
import "../javascripts/shared/components/phone-input"
import "../javascripts/shared/components/url-without-scheme"
import "../javascripts/shared/components/back-to-top"
import "../javascripts/site/components/list-reveal"
import "../javascripts/site/components/form-group"
import "../javascripts/site/components/trix-links"
import "../javascripts/site/components/image-carousel"
import "../javascripts/site/components/swedish-page-popup"

import "../javascripts/site/pages/mission-page"
import "../javascripts/site/pages/mission-search-page"
import "../javascripts/site/pages/mission-search-filter"
import "../javascripts/site/pages/mission-search-history"
import "../javascripts/site/pages/mission-search-status"
import "../javascripts/site/pages/mission-application-page"
import "../javascripts/site/pages/activities-page"
import "../javascripts/site/pages/activity-application-page"
import "../javascripts/site/pages/organizations-page"
import "../javascripts/site/pages/contact-page"
import "../javascripts/site/pages/users-page"
import "../javascripts/site/pages/register-organization-page"
import "../javascripts/site/pages/join-organization-page"

// VB components
import "../javascripts/shared/components/vb-web-header"
import "../javascripts/shared/components/tags-carousel-vb"

// Accessibility
import "../javascripts/site/a11y"

import LazyLoad from "vanilla-lazyload"

new LazyLoad({
  // Your custom settings go here
  unobserve_entered: true,
})
